import type { ProspectClosingChecklistDto } from '../../services/tenantApi';
import { groupStateFromClosingChecklist, personalFromClosingChecklist } from './apply-closing-checklist';
import type { ClosingGroupState, ClosingPersonalState } from './closing-model';

export interface ClosingLocalFiles {
  utilityFile: File | null;
  housemateFile: File | null;
  padFiles: Record<string, File>;
  voidChequeFiles: Record<string, File>;
  eTransferFiles: Record<string, File>;
}

export function hasPendingClosingFiles(local: ClosingLocalFiles): boolean {
  if (local.utilityFile || local.housemateFile) return true;
  return (
    Object.keys(local.padFiles).length > 0 ||
    Object.keys(local.voidChequeFiles).length > 0 ||
    Object.keys(local.eTransferFiles).length > 0
  );
}

/** Apply server checklist; optionally keep in-flight local file picks (background refresh). */
export function applyClosingChecklistDto(
  dto: ProspectClosingChecklistDto,
  currentGroup: ClosingGroupState,
  options?: { resetLocalFiles?: boolean },
): {
  group: ClosingGroupState;
  personal: Record<string, ClosingPersonalState>;
  resetLocalFiles: boolean;
} {
  return {
    group: groupStateFromClosingChecklist(dto, currentGroup),
    personal: personalFromClosingChecklist(dto),
    resetLocalFiles: options?.resetLocalFiles ?? true,
  };
}
